<template>
  <div class="data-table-page">

    <div style="font-size: 18px;text-align: left; margin-bottom: 12px; border-bottom: 2px solid gray; padding: 12px 0">
      数据介绍：数据通过IEC 104、Modbus等传输协议进行采集获取，
      包含如数据来源、数据来源功能、设备效率等重要物理参数，
      用以支撑系统优化、运维等算法业务的正常运行。
    </div>

        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="id"
            label="数据ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="date"
            label="数据产生时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="calculateTime"
            label="数据计算时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="groupId"
            label="数据来源群组ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="groupName"
            label="数据来源群组名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="positionId"
            label="数据来源群组功能ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="positionName"
            label="数据来源群组功能名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="calcValue"
            label="设备效率指标">
          </el-table-column>
          <el-table-column
            align="center"
            prop="systemName"
            label="数据来源系统名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="systemId"
            label="数据来源系统ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="digest"
            label="数据摘要">
          </el-table-column>
          <el-table-column
            align="center"
            prop="blockTime"
            label="区块时间">
          </el-table-column>

        </el-table>

        <el-pagination
          @current-change="fetchList"
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="totalNum">
        </el-pagination>

        <div style="text-align: right;font-size: 15px;margin-top: 0">
          数据来源：{{source}}<br>
          合约地址：0xeac56ab585a74a51705fdc2cbfe113e9482ad197 <br>
          分页接口：http://47.106.246.157:34568/ems-els/evidence/page?cur=1&size=10
        </div>
      </div>

</template>

<script>

export default {
  data() {
    return {
      currentPage: 1,
      tableData: [],
      totalNum: 10,
      source: "榆林零碳智慧能源中心"
    }
  },
  components: {},
  computed: {},

  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.$http(null, '/data/ems-els/evidence/page', {
        cur: this.currentPage++,
        size: 10
      }, 'get').then(res => {
        this.tableData = res.records
        this.currentPage = res.current
        this.totalNum = res.total
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.data-table-page::v-deep {
  padding: 20px;

  .el-table, .el-table__expanded-cell, .el-table tr, .el-table .el-table__expanded-cell, .el-table th.el-table__cell{
    background: transparent;
  }

  .el-table, .el-table thead {
    color: #fff;
  }



  .el-table__body {
    tr:hover>td{
      color: rgba(29, 35, 47, 1);
    }
  }

  .el-pagination {
    margin-top: 20px;
  }

  .el-pagination button:disabled, .el-pager li, .el-pagination .btn-next, .el-pagination .btn-prev{
    background: transparent;
    color: #fff;
  }

  .el-pager li.active {
    background: #fff;
    color: rgba(29, 35, 47, 1);
  }

}

.layout-container {
  height: 100vh;

  .el-aside {
    background-color: #232323;

    .el-menu {
      border-right: none;

    }
  }


}

</style>
